import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../http.service';
import { ProductReviewResponse } from '../../../models/admin/reviews.model';

@Injectable({
  providedIn: 'root'
})
export class ReviewsService extends HttpService<any, ProductReviewResponse> {
  private reviewListSubject = new BehaviorSubject<ProductReviewResponse | null>(null);
  readonly reviewsList$ = this.reviewListSubject.asObservable();

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'reviews');
  }

  getAllReviews(page = 1, limit = 10): Observable<ProductReviewResponse | null> {
    return this.getPagedGeneral('reviews', page, limit).pipe(
      tap((response) => this.reviewListSubject.next(response)),
      catchError(() => of(null))
    );
  }

  getFilteredReviews(entity: any): Observable<ProductReviewResponse | null> {
    return this.filterAllActionPaged(entity, '').pipe(
      tap((response) => this.reviewListSubject.next(response)),
      catchError(() => of(null))
    );
  }

  updateReviewStatus(payload: { ids: number[]; new_status: string }): Observable<any> {
    console.log('Updating review status with payload:', payload);
    return this.update(payload, '', 'update-status').pipe(
      tap((response) => {
        if (response) {
          const currentList = this.reviewListSubject.value;

          if (currentList && Array.isArray(currentList.records)) {
            const normalizedIds = payload.ids.map((id) => Number(id)); // ensure consistent comparison

            const updatedData = currentList.records.map((item) => {
              const itemId = Number(item.id);
              const shouldUpdate = normalizedIds.includes(itemId);
              if (shouldUpdate) {
                return { ...item, status: payload.new_status };
              }

              return item;
            });

            const updatedList = {
              ...currentList,
              records: updatedData
            };

            this.reviewListSubject.next(updatedList);
          }
        }
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }

  deletereviewByID(id: number): Observable<any> {
    return this.delete(id, '', 'admin').pipe(
      tap(() => {
        const currentList = this.reviewListSubject.value;
        if (currentList && Array.isArray(currentList.records)) {
          const updatedData = currentList.records.filter((item) => Number(item.id) !== id);
          this.reviewListSubject.next({ ...currentList, records: updatedData });
        }
      }),
      catchError((error) => {
        console.error('Error deleting review:', error);
        return of(null);
      })
    );
  }

  getReviewByID(id: number): Observable<ProductReviewResponse | null> {
    return this.getById(id, '', 'admin');
  }
}
